import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import PartnerForm from './PartnerForm'
import { startSxpProxy } from '../../utils/api'
import { ADMIN_PROJECT_ID } from '../../utils/constants'
import { IconButton } from '@mui/material'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import { OrganizationIntent, PartnerTable } from '../administration/constants'
import { PartnerProps } from '../administration/models'
import { radiologyEndPoint } from '../Radiology/RadiologyEndPoints'

const EditOrganization = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [partner, setPartner] = useState<PartnerProps>({
    type: '',
    name: '',
    phoneNumber: '',
    status: '',
    fhirId: '',
    id: '',
    isLab: false,
    isRadiology: false,
    isVendorRelate: false,
    isCustomerRelate: false,
  })
  const getOrganizationById = () => {
    startSxpProxy(ADMIN_PROJECT_ID, OrganizationIntent?.getOrganizationById, {
      id,
    })?.then((data) => {
      const partner = data?.data?.organization_by_pk
      setPartner((prev) => ({
        ...prev,
        id: partner?.id?.toString() ?? '',
        name: partner?.name ?? '',
        phoneNumber: partner?.mobile_number ?? '',
        status: partner?.status ?? '',
        type: partner?.type ?? '',
        odoo_partner_id: partner?.odoo_partner_id ?? '',
        isLab: partner?.isLab ? true : false,
        location: partner?.location ?? '',
        isRadiology: partner?.isRadiology ? true : false,
        isCustomerRelate: partner?.isCustomerRelate ? true : false,
        isVendorRelate: partner?.isVendorRelate ? true : false,
        price_list: partner?.price_list ?? '',
        email: partner?.email ?? '',
        department: partner?.department ?? '',
        street_no: partner?.street_no ?? '',
        street: partner?.street,
        state: partner?.state,
        pin: partner?.pin,
        city: partner?.city,
        gst: partner?.gst,
        pan: partner?.pan,
      }))
    })
  }
  useEffect(() => {
    getOrganizationById()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <>
      {partner?.id ? (
        <div className='organization-container'>
          <IconButton
            onClick={() => navigate(radiologyEndPoint?.referredOut)}
            className='organization-icon-content'
          >
            <KeyboardBackspaceIcon className='back-btn-admin' />
          </IconButton>
          <PartnerForm partner={partner} />
        </div>
      ) : (
        <p>{PartnerTable?.invalidPartnerID}</p>
      )}
    </>
  )
}
export default EditOrganization
